import { getProgramLevelsUrl } from "../config/Config";
import { getRequest } from "./ServiceHelper";

export class ProgramLevelService {
  static getProgramLevels = () => {
    return getRequest(getProgramLevelsUrl());
  };
}
